import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-validation-error',
  template: `
    <small *ngIf="control?.touched && control?.invalid && control?.errors" class="text-danger">
      <ng-container *ngIf="control.errors['required']">This field is required</ng-container>
      <ng-container *ngIf="control.errors['minlength']">Minimum length not met</ng-container>
    </small>
  `,
})
export class ValidationErrorComponent {
  @Input() control!: AbstractControl | null;
}
